import React from "react";
import HeroThree from "../Components/Hero/HeroThree";
import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/ProductsDetails/RawCottonAbout.jpg";
import coreImg1 from "../assets/img/ProductsDetails/RawCottonOurStrength.jpg";
import PageBanner from "../Components/PageBanner";
import bannerBg from '../assets/img/Banners/Productpagebanner.jpg';

const Rawcotton = () => {
  return (
    <>
      {/* <HeroThree /> */}
      <PageBanner title='Raw Cotton' bannerBg={bannerBg} currentPage='Raw Cotton' />
      <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 pe-xl-4 col-12">
              <div className="content-block-img justify-content-center">
                <img src={coreImg1} alt="" />
              </div>
            </div>
            <div className="col-xl-6 ps-xl-5 col-lg-6 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>About Raw Cotton </h2>
                <p>
                Cotton is a natural fiber harvested from the cotton plant, serving as the foundation of the global textile industry. Grown in tropical and subtropical regions, cotton thrives in areas with a frost-free growing period of at least 150 days per year. 
                </p>
                <br></br>
                <p>
                After harvesting, cotton fiber is separated from the seed and packaged into bales weighing between 75 to 220 kg. Cotton seeds are further processed to extract oil for cooking and produce meal for animal feed. Asia dominates the cotton industry, with China and India together accounting for over half of the world’s cotton production. While India is a major exporter, China is the leading consumer and importer. 
                </p>
                <br></br>
                <p>
                The United States ranks as the world’s largest exporter and third-largest producer, with more than 50 other countries contributing to global cotton production. 
                </p>
              </div>
              {/* <div className="checked-features-list style-2">
                <ul>
                  <li>Brand Identity</li>
                  <li>Website Design &amp; Development</li>
                  <li>SEO &amp; Analytics</li>
                </ul>
              </div> */}
              {/* <Link to="/about" className="theme-btn style-3 mt-30">
                click here
              </Link> */}
            </div>
          </div>
          <div className="row align-items-center section-padding pb-0">
            <div className="col-xl-6 col-lg-6 col-12 mt-5 mt-lg-0 order-2 order-lg-1">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>Our Strength in Cotton </h2>
                <p>
                  Leveraging strong industry relationships and a significant
                  domestic presence in key cotton-producing markets, our Cotton
                  Platform has steadily expanded its operations, earning a
                  trusted reputation among suppliers and customers.
                </p>
                <br></br>
                <p>
                  We are a leading force in South India’s domestic cotton trade,
                  ensuring seamless supply chain operations. Our Group has
                  established an advanced research division, utilizing
                  cutting-edge technology to analyze critical factors such as
                  consumption patterns, weather conditions, economic trends,
                  political developments, and macroeconomic indicators.
                </p>
                <br></br>
                <p>
                  Our expertise in monitoring and managing supply and demand
                  dynamics gives us a competitive edge. Operating around the
                  clock, we stay ahead of market trends and provide reliable,
                  timely deliveries to spinning mills worldwide. Our success is
                  built on strategic alliances with producers and cooperative
                  organizations.
                </p>
              </div>
              <div className="checked-features-list style-2">
                <h6>Cotton Varieties We Offer </h6>
                <div className="row">
                  <div className="col-6">
                    <ul>
                      <li>HANKAR-6</li>
                      <li>V-797 </li>
                      <li>MECH-1 </li>
                    </ul>
                  </div>
                  <div className="col-6">
                    <ul>
                      <li>MCU-5 </li>
                      <li>DCH-32 </li>
                      <li>Imported Cotton </li>
                    </ul>
                  </div>
                </div>
              </div>
              <Link to="/contact" className="theme-btn style-3 mt-30">
                Contact Us
              </Link>
            </div>
            <div className="col-xl-6 col-lg-6 ps-xl-5 col-12 order-1 order-lg-2">
              <div className="content-block-img justify-content-center">
                <img src={coreImg2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
                                
export default Rawcotton;
